// extracted by mini-css-extract-plugin
export default {"root":"IconSelfCatering_root__UYKvt"};